import { Button } from "@miror-ui/components";
import { Image } from "shared/components/atoms/Image";
import { zIndex } from "shared/styles";
import { styled } from "twin.macro";

const Modal = styled.div<{
  visible: boolean;
}>`
  position: fixed;
  z-index: ${zIndex.floating};
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: ${({ visible }) => (visible ? "flex" : "none")};
  align-items: center;
  justify-content: center;
  max-width: 640px;
  margin: 0 auto;
`;

interface Props {
  onClick: () => void;
  onClose: () => void;
}

export const TarotCardModal = ({ onClick, onClose }: Props) => {
  return (
    <Modal visible tw="animate-fade-in">
      <div tw="grid">
        <Image
          src={"/media/images/free_fortune/tarot_1_card_4.png"}
          width={205}
          height={381}
          layout="fixed"
          tw="mx-auto"
        />
        <div tw="grid grid-flow-col gap-2">
          <Button
            onClick={onClick}
            tw="h-[42px] from-grape to-grape px-4 cursor-pointer z-10"
          >
            このカードで占う
          </Button>
          <Button
            onClick={onClose}
            tw="h-[42px] bg-none border border-solid border-grape text-grape px-4 cursor-pointer z-10"
          >
            選び直す
          </Button>
        </div>
      </div>
      <div
        tw="absolute inset-0 bg-[rgba(255, 255, 255, .1)]"
        onClick={onClose}
      />
    </Modal>
  );
};
